import { PipeTransform } from '@angular/core';
var GetAttachmentNamePipe = /** @class */ (function () {
    function GetAttachmentNamePipe() {
    }
    GetAttachmentNamePipe.prototype.transform = function (path) {
        if (!path) {
            return '';
        }
        var segments = path.split('/');
        return segments[segments.length - 1];
    };
    return GetAttachmentNamePipe;
}());
export { GetAttachmentNamePipe };
